import styled from "styled-components";
import { CenterizedPage } from "../CenterizedPage";

export const Container = styled(CenterizedPage)`
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.5);
`;
